import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-5"},[_c(VRow,{staticStyle:{"margin-top":"10px"}},[_c(VCol,[_c(VCard,{attrs:{"height":"400px"}},[_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('column-chart',{staticStyle:{"width":"100%","height":"200px"},attrs:{"library":_vm.chartOptions,"data":_vm.installedVersionsData}})],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }